module.exports = __webpack_public_path__ + "static/media/photo101.a7c44270.jpg";